/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function AddColumnLeft({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g fill="currentColor" clipPath="url(#AddColumnLeft_svg__a)"><path fillRule="evenodd" d="M13 .9a2.6 2.6 0 0 1 2.6 2.6v9a2.6 2.6 0 0 1-2.6 2.6H7.5a.6.6 0 1 1 0-1.2h.9V2.1h-.9a.6.6 0 0 1 0-1.2H13ZM9.6 2.1v11.8H13a1.4 1.4 0 0 0 1.4-1.4v-9A1.4 1.4 0 0 0 13 2.1H9.6Z" clipRule="evenodd" /><path d="M3.25 4.9a.6.6 0 0 0-.6.6v1.9H.75a.6.6 0 0 0 0 1.2h1.9v1.9a.6.6 0 1 0 1.2 0V8.6h1.9a.6.6 0 0 0 0-1.2h-1.9V5.5a.6.6 0 0 0-.6-.6ZM5.85 1.5a.6.6 0 0 0-.6-.6h-1a1.6 1.6 0 0 0-1.6 1.6V3a.6.6 0 0 0 1.2 0v-.5c0-.22.18-.4.4-.4h1a.6.6 0 0 0 .6-.6ZM2.65 13a.6.6 0 1 1 1.2 0v.5c0 .22.18.4.4.4h1a.6.6 0 1 1 0 1.2h-1a1.6 1.6 0 0 1-1.6-1.6V13Z" /></g><defs><clipPath id="AddColumnLeft_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;